<div style="height: 364px; width: 336px;padding: 30px; display: flex;">
    <div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
    </div>
    <div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
    </div>
    <div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
    </div>
    <div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
    </div>
    <div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
    </div>
    <div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
    </div>
    <div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
    </div>
    <div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
        <div style="padding: 10px;">
            <zuper-shimmer-loading [shape]="'square'" [width]="'15px'"></zuper-shimmer-loading>
        </div>
    </div>
</div>
